<template>
	<div style="background-color:#fffcf7;" class="container">
		<headMenu />
		<div class="w-100 p-3 bg-ingo">
			<div class="text-center">
				<img
					alt="درباره ما شرکت فناوری  رهنمای دنیای آینده (فردا)"
					title="درباره ما شرکت فناوری  رهنمای دنیای آینده (فردا)"
					:src="require('../../../assets/img/Shape_Title.svg')"
				/>
				<p class="bMikhak text-center text-success" style="font-size: 24px;">
					درباره ایزی تیک
				</p>
			</div>
			<div class="row mt-3">
		    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6 font-weight-bold" style="font-size: 24px; display: flex; align-items: center; text-align: center;">
				ایزی تیک، تجربه ای نوین در آموزش
				<br/>
				ما اینجا هستیم تا نیازهای آموزشی شما را برطرف کنیم!
			</div>
		    <div class="col-sm-12 col-md-12 col-lg-6 col-xl-6">
					<img
						alt="تدریس خصوصی حضوری و آنلاین تمامی مقاطع تحصیلی، رشته‌ها و مهارت‌ها"
						title="تدریس خصوصی حضوری و آنلاین تمامی مقاطع تحصیلی، رشته‌ها و مهارت‌ها"
						class="w-100"
						:src="require('../../../assets/img/Illustration_Home_2.svg')"
					/>
		    </div>
				<div class="col-12 mt-3 text-justify">
					ایزی تیک به عنوان یکی از برندهای زیرمجموعه فناوری رهنمای دنیای آینده (فردا) در سال 1401در صنعت آموزش شروع به فعالیت کرد. ایزی تیک به عنوان راهکاری اثربخش در زمینه‌ی برگزاری تدریس خصوصی به صورت حضوری و آنلاین در کشور فعالیت می‌کند و شما می‌توانید با ثبت نام در ایزی تیک، استاد متناسب با بودجه و زمان خود را از میان اساتیدی که در این پلتفرم ثبت‌نام کرده‌اند، انتخاب کنید.
هدف اصلی ما، ارتقا استانداردهای آموزشی مبتنی بر کیفیت و ارائه محصولی با بهترین عملکرد و خلق ارزش برای کاربران و اساتید است. امنیت، اخلاق‌مداری، مشتری‌محوری، شفافیت و نوآوری ارزش‌هایی هستند که ما برای تحقق آن‌ها تلاش می‌کنیم. ارزش‌هایی که بر آن باور داریم و به منظور ایجاد تجربه‌ای مثبت برای شما در آن مسیر گام بر می‌داریم.
ما به منظور تأمین امنیت و آسایش شما، اساتید را از جنبه های مختلف مورد بررسی قرار می‌دهیم و برای آنان گواهی صلاحیت صادر می‌کنیم تا اساتید و کاربران با خیالی آسوده فعالیت خود را انجام دهند.
				</div>
				<div class="text-success">
					ایزی تیک چگونه نیازهای آموزشی را برطرف می‌کند؟
				</div>
				<div class="col-12 mt-3 text-justify">
					در ایزی تیک می‌توانید مدرس، استاد یا مربی مدنظر خود را در تمامی مقاطع تحصیلی و در همه‌ی رشته‌های درسی، غیردرسی و مهارتی از رشته‌های فنی، هنری، ورزشی و... مشاهده نموده و برای دریافت آموزش به صورت حضوری یا آنلاین، جلسه‌ی تدریس خصوصی رزرو نمایید. جلسات و کلاس‌های آموزشی به دو صورت حضوری و آنلاین انجام می‌شود که تدریس خصوصی به صورت حضوری به دو شکل تدریس در محل استاد و تدریس در محل کاربر انجام می‌گیرد. که شما می‌توانید از میان این گزینه‌ها مناسب‌ترین آن‌ها را با توجه به شرایط خود انتخاب کنید.
همچنین اساتید و مدرسان گرامی که قصد دستیابی به کاربران و شروع فعالیت در ایزی تیک را دارند، می‌توانند از طریق وب‌سایت این مجموعه اقدام به ثبت نام و تکمیل اطلاعات نمایند. ایزی تیک با انجام تبلیغات رایگان، اساتید را در جذب کاربران همراهی نموده و به آنان در این زمینه کمک می‌کند.
				</div>
				<h1 class="m-auto pt-3 font-weight-bold">
					ارزش های ایزی تیک
				</h1>
				<img 
				class="w-100"
				:src="require('../../../assets/img/our_values_lg.svg')"
				alt="ارزش های ایزی تیک"
				title="ارزش های ایزی تیک"
				v-if="windowWidth>1000"
				/>
				<img 
				class="w-100"
				:src="require('../../../assets/img/our_values_sm.svg')"
				alt="ارزش های ایزی تیک"
				title="ارزش های ایزی تیک"
				v-else
				/>
				<div class="col-12 mt-3 text-justify">
					در ایزی تیک، افتخار داریم که شما را در مسیری از یادگیری و توسعه همراهی کنیم. باور ما این است که هر فرصت آموزشی، یک قدم نزدیک‌تر به موفقیت است و ما به عنوان تیم ایزی تیک، متعهد به ارائه بهترین امکانات و خدمات در این مسیر هستیم
از همراهی شما سپاسگزاریم و همیشه برای ارتقاء تجربه آموزشی و رسیدن به اهدافتان، در خدمت شما هستیم.
اگر سوالات یا پیشنهاداتی دارید، خوشحال می‌شویم که آن را با ما در میان بگذارید. ما به همکاری مستمر و موفقیت‌های بیشتر در این مسیر امیدواریم.
از طریق لینک زیر می‌توانید با ایزی تیک در تماس باشید.
				</div>
				<div class="col-12 mt-3">
					<router-link to="/contact">
						<btn
						:textClass="(windowWidth<=960) ? 'm-auto' : ''"
						style_btn="width: 200px;"
						text="ارتباط با ما"
						/>
					</router-link>
				</div>
				<h1 class="d-none text-center pt-3 w-100 font-weight-bold">
					ماموریت و چشم انداز
				</h1>
				<div class="d-none row w-100">
					<div class="col-sm-6 text-justify p-3">
						فناوری رهنمای دنیای آینده (فردا) با نام تجاری ایزی تیک در سال ۱۴۰۱ در صنعت آموزش شروع به فعالیت کرد. ایزی تیک به عنوان راهکاری اثربخش در زمینه‌ی برگزاری تدریس خصوصی به صورت حضوری و آنلاین در کشور فعالیت می‌کند و شما می‌توانید با ثبت نام در ایزی تیک از بین اساتید مختلف، گزینه‌ی متناسب با بودجه و زمان خود از میان آن‌ها انتخاب کنید.
هدف اصلی ما، ارتقا استانداردهای آموزشی مبتنی بر کیفیت و ارائه محصولی با بهترین عملکرد و خلق ارزش برای کاربران و اساتید است. امنیت، اخلاق‌مداری، مشتری‌محوری، شفافیت و نوآوری ارزش‌هایی است که در تلاش برای تحقق آن‌ها هستیم. ارزش‌هایی که بر آن باور داریم و به منظور ایجاد تجربه ای مثبت برای شما در آن مسیر گام بر میداریم.
					</div>
					<div class="col-sm-6 bg-dark">

					</div>
					<div class="col-sm-6 bg-dark">
						

					</div>
					<div class="col-sm-6 text-justify p-3">
						فناوری رهنمای دنیای آینده (فردا) با نام تجاری ایزی تیک در سال ۱۴۰۱ در صنعت آموزش شروع به فعالیت کرد. ایزی تیک به عنوان راهکاری اثربخش در زمینه‌ی برگزاری تدریس خصوصی به صورت حضوری و آنلاین در کشور فعالیت می‌کند و شما می‌توانید با ثبت نام در ایزی تیک از بین اساتید مختلف، گزینه‌ی متناسب با بودجه و زمان خود از میان آن‌ها انتخاب کنید.
هدف اصلی ما، ارتقا استانداردهای آموزشی مبتنی بر کیفیت و ارائه محصولی با بهترین عملکرد و خلق ارزش برای کاربران و اساتید است. امنیت، اخلاق‌مداری، مشتری‌محوری، شفافیت و نوآوری ارزش‌هایی است که در تلاش برای تحقق آن‌ها هستیم. ارزش‌هایی که بر آن باور داریم و به منظور ایجاد تجربه ای مثبت برای شما در آن مسیر گام بر میداریم.
					</div>
				</div>

				
				
		  </div>

			<footerPage />
		</div>
	</div>
</template>

<script>
	import footerPage from  "../../../UI/footer/footer.vue";
	import btn from  "../../../UI/button/btn.vue";
	import headMenu from  "../../../menu/headMenu.vue";
	import leftMenuPublic from  "../../../menu/leftMenuPublic.vue";
	import { indexFinder } from  "../../../assets/library/filter.js";


	export default {
			name: 'teachers_id',
		data(){
			return {
				imgurl: window.imgurl,
				baseurl: window.baseurl,
				flds: [],
				degrees: [],
				category: [],
				location: [],
				indexFinder : indexFinder,
				index_text : -1
			}
		},
		components: {
				btn,
				headMenu,
				footerPage,
				leftMenuPublic,
		},
			props: [],
		mounted(){
			this.$swal.close();
		},
		methods:{
				// *********************************************************************
		}
	}
</script>
<style>

</style>
